import React from "react"
import BlockHero from "@components/common/blockHero"
import BlockModalBtn from "@components/common/blockModalBtn"
import BlockColumns from "@components/common/blockColumns"
import ChangePageBtn from "@components/common/changePageBtn"
import { languageUtils } from "@utils/language"

import Finalizacion from "@images/hitos/finalizacion.jpg"
import Respuesta from "@images/hitos/respuesta.jpg"
import Rsc from "@images/hitos/rscBtn.jpg"

const Index = () => {
  const currentPath = '/gal/fitos-e-estratexia/' // languageUtils.getCurrentPath()

  return (
    <section>
      <div className="element">
        <BlockHero
          title="FITOS E ESTRATEXIA"
          description="A pandemia da COVID-19 marcou o desempeño de Mutua Universal en 2020. A Entidade deulle prioridade á continuidade do servizo en tódolos seus ámbitos de actuación, contribuíndo, deste xeito, a frear o contaxio. Ao mesmo tempo, desenvolveu os seus grandes eixos estratéxicos e culminou con éxito o Plan Estratéxico 2018-2020."
        />
      </div>
      <div className="element">
        <BlockModalBtn
          image={Respuesta}
          to={`${currentPath}resposta-efectiva-a-crise-sanitaria`}
        >
          <span>Resposta efectiva á crise sanitaria</span>
        </BlockModalBtn>
      </div>
      <div className="element-flex">
        <BlockModalBtn
          image={Finalizacion}
          to={`${currentPath}finalizacion-do-plan-estratexico-2018-2020`}
        >
          <span>Finalización do Plan estratéxico 2018-2020</span>
        </BlockModalBtn>
        <BlockModalBtn
          image={Rsc}
          to={`${currentPath}rsc-4.0-traballando-cara-ao-noso-proposito`}
        >
          <span>RSC 4.0: Traballando cara ao noso propósito</span>
        </BlockModalBtn>
      </div>
      <div className="element">
        <BlockColumns
          title="O Plan Estratéxico 2018-2020 e o Plan Director RSC 2018-2020 responden ao propósito, misión, visión e valores da Entidade."
          proposito={{
            title: "Propósito",
            description:
              "Ser socialmente responsables e contribuír á sostibilidade do estado do benestar.",
          }}
          mision={{
            title: "Misión",
            description:
              "Velar pola saúde e o benestar dos nosos mutualistas, xestionando os servizos e as prestacións con rigorosidade e excelencia, comprometidos coa sociedade e a sostibilidade do sistema.",
          }}
          vision={{
            title: "Visión",
            description:
              "Ser excelentes baseándonos nas nosas persoas, a innovación e a orientación aos mutualistas.",
          }}
          valores={{
            title: "Valores",
            description: [
              "Calidade",
              "Profesionalidade",
              "Eficiencia",
              "Integridade",
            ],
          }}
        />
      </div>
      <div className="element changePage">
        <ChangePageBtn />
      </div>
    </section>
  )
}

export default Index
